(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
        var root = document.documentElement;
        var w = document.currentScript.closest('[data-dostepnosc]');
        if (!w) { return; }
        var KZ = 'a11y-zoom', KK = 'a11y-kontrast', KL = 'a11y-linki';
        var KM = 'a11y-motyw';
        var zoomy = [1, 1.12, 1.25, 1.4];

        function zapisz(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
        function czytaj(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

        var poziom = parseInt(czytaj(KZ) || '0', 10);
        if (isNaN(poziom)) { poziom = 0; }

        function ustawZoom() {
            poziom = Math.max(0, Math.min(3, poziom));
            [0,1,2,3].forEach(function(n){root.classList.toggle('a11y-zoom--'+n,n===poziom);});
            zapisz(KZ, poziom);
        }
        function ustawKlase(k, on) {
            root.classList.toggle(k, on);
            zapisz(k, on ? '1' : '0');
        }

        // MOTYW. Klasa `a11y-ciemny` na <html> przestawia zetony kolorow
        // w klasy-uzupelnienie.css; zaden szablon o tym nie wie i nie musi.
        // 'auto' znaczy: nie narzucamy nic i o kolorach decyduje
        // prefers-color-scheme z systemu. Bez zapisanego wyboru telefon startuje
        // w auto, a szerszy ekran w jasnym motywie. Fizyczny czujnik swiatla nie
        // ma stabilnego interfejsu WWW; telefon moze laczyc tryb systemowy z pora
        // dnia albo wlasna automatyka producenta.
        var systemCiemny = window.matchMedia
            ? window.matchMedia('(prefers-color-scheme: dark)')
            : null;

        function ustawMotyw(m, zapisac) {
            var ciemny = m === 'ciemny' || (m === 'auto' && systemCiemny && systemCiemny.matches);
            root.classList.toggle('a11y-ciemny', ciemny);
            var metaMotyw = document.querySelector('meta[name="theme-color"]');
            // Same theme tokens as --tlo in klasy-uzupelnienie.css. Reading
            // computed styles here forced layout while HTML was still parsing,
            // then repeated it for every arriving page stylesheet.
            if (metaMotyw) { metaMotyw.content = ciemny ? '#121211' : '#ece8e1'; }
            if (zapisac) { zapisz(KM, m); }
            w.querySelectorAll('[data-motyw]').forEach(function (b) {
                b.setAttribute('aria-pressed', String(b.getAttribute('data-motyw') === m));
            });
        }

        var zapisanyMotyw = czytaj(KM);
        var mobile = window.matchMedia && window.matchMedia('(max-width: 639px)').matches;
        var motyw = zapisanyMotyw || (mobile ? 'auto' : 'jasny');

        ustawZoom();
        ustawKlase(KK, czytaj(KK) === '1');
        ustawKlase(KL, czytaj(KL) === '1');
        ustawMotyw(motyw, false);

        // Uzytkownik w trybie 'auto' ma isc za systemem takze wtedy, gdy ten
        // zmieni sie przy otwartej stronie (Windows robi to o zmierzchu).
        if (systemCiemny && systemCiemny.addEventListener) {
            systemCiemny.addEventListener('change', function () {
                if (motyw === 'auto') { ustawMotyw('auto', false); }
            });
        }

        w.querySelectorAll('[data-motyw]').forEach(function (b) {
            b.addEventListener('click', function () {
                motyw = b.getAttribute('data-motyw');
                ustawMotyw(motyw, true);
            });
        });

        var otw = w.querySelector('[data-dostepnosc-otworz]');
        var panel = w.querySelector('.dostepnosc__panel');

        function ustawPanel(pokaz) {
            panel.hidden = !pokaz;
            otw.setAttribute('aria-expanded', String(pokaz));
        }

        otw.addEventListener('click', function (e) {
            // Zatrzymujemy tu zdarzenie, zeby nasluch na dokumencie nizej
            // nie potraktowal tego samego klikniecia jako „kliknieto obok"
            // i nie zamknal panelu w tej samej chwili, w ktorej sie otworzyl.
            e.stopPropagation();
            ustawPanel(panel.hidden);
        });

        // Panel zamyka sie klknieciem OBOK i klawiszem Escape. Do 12.09.2026
        // jedynym wyjsciem bylo trafienie ponownie w ten sam przycisk —
        // na telefonie panel zaslanial pol ekranu i trzeba go bylo scigac.
        // Klikniecie WEWNATRZ panelu nie zamyka go: sa tam przyciski, ktore
        // uzywa sie seriami (A+ wciskane trzy razy z rzedu).
        panel.addEventListener('click', function (e) { e.stopPropagation(); });

        document.addEventListener('click', function () {
            if (!panel.hidden) { ustawPanel(false); }
        });

        document.addEventListener('keydown', function (e) {
            if ((e.key === __pewniaki_inline_cfg[0] || e.key === __pewniaki_inline_cfg[1]) && !panel.hidden) {
                ustawPanel(false);
                otw.focus();
            }
        });

        w.querySelectorAll('[data-font]').forEach(function (b) {
            b.addEventListener('click', function () {
                var v = b.getAttribute('data-font');
                if (v === '+') { poziom++; } else if (v === '-') { poziom--; } else { poziom = 0; }
                ustawZoom();
            });
        });

        function przelacznik(sel, klasa) {
            var b = w.querySelector(sel);
            if (!b) { return; }
            b.setAttribute('aria-pressed', String(root.classList.contains(klasa)));
            b.addEventListener('click', function () {
                var on = !root.classList.contains(klasa);
                ustawKlase(klasa, on);
                b.setAttribute('aria-pressed', String(on));
            });
        }
        przelacznik('[data-kontrast]', KK);
        przelacznik('[data-linki]', KL);

        var rb = w.querySelector('[data-reset]');
        if (rb) {
            rb.addEventListener('click', function () {
                poziom = 0; ustawZoom();
                ustawKlase(KK, false); ustawKlase(KL, false);
                w.querySelectorAll('[aria-pressed]').forEach(function (x) {
                    x.setAttribute('aria-pressed', 'false');
                });
            });
        }
    })();
})();
